// Who5CardResults.js
import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const Who5CardResults = ({
  title,
  tooltipText,
  dataKey,
  transformedWho5List,
  height = 300,
}) => {
  // Función para determinar el color en función del valor
  const getColor = (value) => {
    if (value <= 29) {
      return "#ff4600"; // Rojo
    } else if (value > 29 && value < 50) {
      return "#ff8354"; // Naranja
    }
    return "#29ade6"; // Azul
  };

  // 1. Verificar si todos los puntos tienen el mismo valor
  const allValues = transformedWho5List.map((point) => point[dataKey]);
  const uniqueValues = new Set(allValues);
  const isAllSame = uniqueValues.size === 1;

  return (
    <div className="anali-el">
      <p className="anali-title">{title}</p>
      <div className="anali-result-container">
        <ResponsiveContainer width="100%" height={height}>
          <LineChart
            data={transformedWho5List}
            margin={{ top: 50, right: 0, left: -30, bottom: 0 }}
          >
            {/* Si NO todos los puntos tienen el mismo valor, definimos gradiente dinámico */}
            <defs>
              {!isAllSame && (
                <linearGradient id="dynamicGradient" x1="0" y1="0" x2="1" y2="0">
                  {transformedWho5List.map((point, index) => {
                    const color = getColor(point[dataKey]);
                    // Distribuir paradas de 0% a 100% según el índice
                    const position =
                      transformedWho5List.length > 1
                        ? (index / (transformedWho5List.length - 1)) * 100
                        : 0;

                    return (
                      <stop
                        key={`stop-${index}`}
                        offset={`${position}%`}
                        stopColor={color}
                      />
                    );
                  })}
                </linearGradient>
              )}
            </defs>

            <YAxis
              type="number"
              domain={[0, 100]}
              axisLine={{ strokeWidth: 0 }} // Ocultar línea del eje
              tickLine={{
                stroke: "#777777", // Color de las líneas de los ticks
                strokeWidth: 1, // Grosor de las líneas
                length: 6, // Longitud de las líneas
              }}
              tick={{
                fontSize: 12,
                fill: "#777777", // Color de los números
              }}
            />

            <XAxis
              axisLine={{ strokeWidth: 0 }}
              dataKey="fecha"
              padding={{ left: 50, right: 40 }}
              dy={10}
              tick={{
                fontSize: 12,
                fill: "#777777",
              }}
            />
            <Tooltip />

            <Line
              key={dataKey}
              type="monotone"
              dataKey={dataKey}
              // 2. Si todos los puntos tienen el mismo valor, usamos un solo color.
              //    Si hay valores distintos, utilizamos el gradiente dinámico.
              stroke={isAllSame ? getColor(allValues[0]) : "url(#dynamicGradient)"}
              strokeWidth={8}
              label={(props) => {
                const { x, y, value, index } = props;
                const color = getColor(value);
                return (
                  <text
                    key={`label-${index}`}
                    x={x}
                    y={y - 20}
                    fontSize={36}
                    fontWeight="bold"
                    textAnchor="middle"
                    fill={color}
                    className="recharts-text recharts-label"
                  >
                    <tspan x={x} dy="0em">
                      {value}
                    </tspan>
                  </text>
                );
              }}
              dot={(props) => {
                const { cx, cy, value, index } = props;
                const color = getColor(value);
                return (
                  <circle
                    key={`dot-${index}`}
                    cx={cx}
                    cy={cy}
                    r={6}
                    fill={color}
                    stroke="#fff"
                    strokeWidth={4}
                  />
                );
              }}
              activeDot={(props) => {
                const { cx, cy, value, index } = props;
                const color = getColor(value);
                return (
                  <g
                    className="recharts-layer recharts-active-dot"
                    key={`activeDot-${index}`}
                  >
                    <circle
                      cx={cx}
                      cy={cy}
                      r={8}
                      fill={color}
                      stroke="#fff"
                      strokeWidth={2}
                      className="recharts-dot"
                    />
                  </g>
                );
              }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default Who5CardResults;
